import { formatNumber } from '@angular/common';
import {
  SkyClubCard,
  TrackerFooter
} from '@com-delta-idp/mnx-skymiles-overview-ui';
import { SkyClubTrackerConstant as Constant } from '../models';
import { CardImage, VisitSpend } from '../models/aem/visit-spend.interface';
import { DscSpendTracker } from '../models/api/tracker-details.interfaces';
import { getObject } from './amex-skyclub-tracker.utils';

export const isDiscontinuedDate = (date: string | undefined) => {
  if (!date) return false;
  const discontinuedDate = new Date(date);
  return discontinuedDate.getTime() > Date.now();
};

export const getImageObj = (imageObj: CardImage[], value: string) => {
  if (imageObj !== undefined) {
    return {
      src: imageObj.find((image) => image.id === value)?.src || '',
      alt: imageObj.find((image) => image.id === value)?.alt || ''
    };
  } else {
    return {
      src: '',
      alt: ''
    };
  }
};

export const sortCards = (cards: SkyClubCard[]): SkyClubCard[] => {
  return cards.sort((a, b) => Number(b.thresholdMet) - Number(a.thresholdMet));
};

export const getSplitYear = (date: string) => {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  return year.toString();
};

export const getSpendTracker = (
  aem: VisitSpend,
  trackerContent: DscSpendTracker
): TrackerFooter => {
  const currentObj = getObject(trackerContent.DSCSpend, Constant.CURRENT);
  return {
    total: {
      title:
        Constant.USD +
        formatNumber(
          currentObj.thresholdMet
            ? currentObj.thresholdAmt
            : currentObj.spentAmt,
          Constant.EN_US,
          '1.0-0'
        ),
      subtitle: currentObj.thresholdMet
        ? ''
        : aem.spendTracker.totalDesc.replace(
            Constant.YEAR,
            getSplitYear(currentObj.spendThruDate)
          )
    },
    max: Constant.USD + currentObj.thresholdAmt / 1000 + 'k',
    iconLink: {
      isIcon: true,
      information: aem.spendTracker.tooltipInfo,
      label: '',
      url: ''
    },
    spendLink: {
      label: currentObj.thresholdMet
        ? aem.spendTracker.maxoutDesc
        : aem.spendTracker.balanceDesc
            .replace(
              Constant.REMAIN,
              Constant.USD +
                formatNumber(currentObj.remainderAmt, Constant.EN_US, '1.0-0')
            )
            .replace(Constant.YEAR, currentObj.medallionYear),
      url: aem.searchUrl
    }
  };
};
